import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import BlueLine from '../../BlueLine';
import HeaderTitle from '../../HeaderTitle';
import Language from '../../Language';

import withTranslations from '../../../utils/translations/withTranslations';

import './Header.css';

const Header = ({ translate }) => {
  return (
    <div className="Header">
      <BlueLine />
      <div className="Header__Wrapper">
        <div>
          <HeaderTitle />
          <Language />
        </div>
        <ul className="Header__Menu">
          <li>
            <NavLink exact to="/" activeClassName="Header__Menu__Item--active">
              {translate('menu.overview')}
            </NavLink>
          </li>
          <li>
            <NavLink
              exact
              to="/fiche"
              activeClassName="Header__Menu__Item--active"
            >
              {translate('menu.new')}
            </NavLink>
          </li>
          <li>
            <NavLink exact to="/logout">
              {translate('menu.logout')}
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default withRouter(withTranslations(Header));
